import PageLayout from "components/common/PageLayout";
import Header from "components/Header";
import Footer from "components/Footer";
import "aos/dist/aos.css";
import ENDPOINTS from "constants/endpoints";
import useFetch from "hooks/useFetch";
import StoreCard from "components/common/StoreCard/StoreCard";

import AliceCarousel from "react-alice-carousel";
import background from "assets/images/background.mp4";
import responsive from "assets/images/responsive-video.mp4";
import "react-alice-carousel/lib/alice-carousel.css";

import FeaturedHome1 from "assets/images/home-featured-2/1.jpeg";
import FeaturedHome2 from "assets/images/home-featured-2/2.jpeg";
import FeaturedHome6 from "assets/images/home-featured-2/3.jpeg";
import FeaturedHome7 from "assets/images/home-featured-2/3-responsive.jpeg";

import FeaturedHome3 from "assets/images/home-featured/1.jpeg";
import FeaturedHome4 from "assets/images/home-featured/2.jpeg";
import FeaturedHome5 from "assets/images/home-featured/3.jpeg";

import icon1 from "assets/images/icons/1.png";
import icon2 from "assets/images/icons/2.png";
import icon3 from "assets/images/icons/3.png";

import { routes } from "routing/routes";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import Aos from "aos";

import HomeSlider1 from "assets/images/home-slider/1.jpg";
import HomeSlider2 from "assets/images/home-slider/2.jpg";
import HomeSlider3 from "assets/images/home-slider/3.jpg";
import HomeSlider4 from "assets/images/home-slider/4.jpg";
import { useTitle } from "react-use";

import Typewriter from "typewriter-effect";

const Home = ({ authToken }) => {
  const [error, loading, done, products] = useFetch(
    {
      method: "get",
      url: ENDPOINTS.getFeaturedProductsHome(),
      params: { token: authToken },
    },
    "Error al cargar los productos, actualizar la pagina para reintentar."
  );

  useTitle(process.env.REACT_APP_PAGE_TITLE);

  useEffect(() => {
    Aos.init();
    Aos.refresh();
  }, []);

  const handleDragStart = (e) => e.preventDefault();

  const items = [
    <div
      style={{ backgroundImage: `url(${HomeSlider1})` }}
      className="home-slide"
    >
      <div className="wrapper">
        <p className="p1">Winter ♥️♥️♥️.</p>
      </div>
    </div>,
    <div
      style={{ backgroundImage: `url(${HomeSlider2})` }}
      className="home-slide"
    >
      <div className="wrapper">
        <p className="p1">
          Te acompañamos en el outfit de tu bebe, desde prematuro hasta los 5
          años.
        </p>
      </div>
    </div>,
    <div
      style={{ backgroundImage: `url(${HomeSlider3})` }}
      className="home-slide"
    >
      <div className="wrapper">
        <p className="p1">Piensa, Sueña, Cree y Atrévete.</p>
      </div>
    </div>,
    <div
      style={{ backgroundImage: `url(${HomeSlider4})` }}
      className="home-slide"
    >
      <div className="wrapper">
        <p className="p1">Estate atengo a las promos lanzamiento</p>
      </div>
    </div>,
  ];

  return (
    <>
      <PageLayout>
        <Header />

        {/* <AliceCarousel
          autoPlay
          autoPlayInterval={10000}
          infinite
          disableButtonsControls
          mouseTracking
          items={items}
        ></AliceCarousel> */}
        <div className="principal-container">
          <div className="text">
            <Typewriter
              options={{
                strings: [
                  "Se parte de nuestra comunidad.",
                  "Amor, elegancia y estilo.",
                  "Hacé que tu amigo peludo brille con un toque de sofisticación!",
                ],
                autoStart: true,
                loop: true,
                skipAddStyles: true,
                wrapperClassName: "texts-spans",
                cursorClassName: "cursor-text",
                delay: 30,
                deleteSpeed: 10,
              }}
            />
          </div>
          <video className="background-video" autoPlay loop muted playsInline>
            <source src={background} type="video/mp4" />
          </video>

          <video className="video-responsive" autoPlay loop muted playsInline>
            <source src={responsive} type="video/mp4" />
          </video>

          <div className="mask"></div>
        </div>

        <div className="home-featured">
          <div className="wrapper">
            <div className="cols">
              <Link
                to="tienda/pijamas"
                className="col aos-init aos-animate"
                data-aos="zoom-in"
                data-aos-offset="200"
              >
                <img src={FeaturedHome3} alt="" />
              </Link>
              <Link
                to="tienda/pijamas"
                className="col aos-init aos-animate"
                data-aos="zoom-in"
                data-aos-offset="200"
              >
                <img src={FeaturedHome4} alt="" />
              </Link>
              <Link
                to="tienda/pijamas"
                className="col aos-init aos-animate"
                data-aos="zoom-in"
                data-aos-offset="200"
              >
                <img src={FeaturedHome5} alt="" />
              </Link>
            </div>
          </div>
        </div>

        <section className="home-section showcase">
          <div className="wrapper">
            <h2>Novedades</h2>

            {loading && (
              <div className="showcase-loading">
                <i className="fas fa-spinner fa-pulse"></i>
                <span>Cargando</span>
              </div>
            )}

            {!!error && <p>{error}</p>}
            {done && products.length === 0 && (
              <p>No hay productos destacados aún.</p>
            )}

            <div className="product-grid">
              {products.map((product, index) => (
                <StoreCard
                  index={index}
                  imagePath={process.env.REACT_APP_PRODUCT_THUMBNAIL_IMAGE_PATH}
                  key={product.id}
                  image={product.image.filename}
                  title={product.title}
                  isProduct={true}
                  product={product}
                />
              ))}
            </div>
          </div>
        </section>

        <div className="services-container wrapper">
          <div className="services-details">
            <img src={icon1} />
            <h1>Elegí el outfit que más te guste para tu canino!</h1>
            <p>Si queres más de uno, sumalos a tu carrito.</p>
          </div>
          <div className="services-details">
            <img src={icon2} />
            <h1>Paga con el medio de pago que quieras</h1>
            <p>Utilizamos la tecnología de Mercado Pago.</p>
          </div>
          <div className="services-details">
            <img src={icon3} />
            <h1>Recibí el producto que esperás.</h1>
            <p>Elegí la forma de entrega que prefieras y listo!</p>
          </div>
        </div>

        <div className="home-featured-2">
          <div className="wrapper">
            <div className="cols">
              <Link to="tienda/pijamas" className="col">
                <img
                  src={FeaturedHome1}
                  data-aos="flip-right"
                  data-aos-offset="100"
                  className="aos-init aos-animate"
                  alt=""
                />
              </Link>
              <Link to="tienda/pijamas" className="col">
                <img
                  src={FeaturedHome2}
                  data-aos="flip-left"
                  data-aos-offset="100"
                  className="aos-init aos-animate"
                  alt=""
                />
              </Link>
              <Link to="tienda/pijamas" className="col-special">
                <img
                  src={FeaturedHome6}
                  data-aos="flip-right"
                  data-aos-offset="100"
                  className="aos-init aos-animate"
                  alt=""
                />
              </Link>
              <Link to="tienda/pijamas" className="col-special-responsive">
                <img
                  src={FeaturedHome7}
                  data-aos="flip-right"
                  data-aos-offset="100"
                  className="aos-init aos-animate"
                  alt=""
                />
              </Link>
              {/* <Link to="tienda/nio-de-2-a-5-aos" className="col">
                <img
                  src={FeaturedHome2}
                  data-aos="flip-left"
                  data-aos-offset="100"
                  className="aos-init aos-animate"
                  alt=""
                />
              </Link> */}
            </div>
          </div>
        </div>

        {/*    <Link className="showroom" to={routes.registro.path} target="_blank">
          <div className="wrapper">
            <p>Compras comunitarias</p>
          </div>
        </Link> */}
      </PageLayout>
      <Footer />
    </>
  );
};

export default Home;
